import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Label,
  FormFeedback,
  Button,
  Card,
  CardBody,
  CardTitle,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  ModalFooter,
  Spinner,
  OffcanvasBody,
  Offcanvas,
  OffcanvasHeader,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import CustomerTypeService from "../../../services/OrderingServices/CustomerTypeService";

// Validation Schema
const validationSchema = Yup.object({
  // username: Yup.string().required("Username is required"),
  name: Yup.string().required("Customer type is required"),
  description: Yup.string().required("Description is required"),

  discountPercentage: Yup.string().required(
    "Discount percentage is required (Only Number)"
  ),

  // password: Yup.string()
  //   .min(6, "Password must be at least 6 characters")
  //   .matches(
  //     /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
  //     "Password must contain at least one uppercase, one lowercase, and one number"
  //   )
  //   .required("Password is required"),
});

const CustomerTypeForm = ({ selectedUnit, modal, toggleModal, fetchUnit }) => {
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      id: selectedUnit?.id || "",

      // username: selectedUnit?.username || "",
      name: selectedUnit?.name || "",
      description: selectedUnit?.description || "",
      discountPercentage: selectedUnit?.discountPercentage || "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        setLoading(true);

        if (values.id) {
          await CustomerTypeService.update(values);
          toast.success("Customer type updated successfully.");
        } else {
          await CustomerTypeService.create(values);
          toast.success("New customer type is added successfully");
          resetForm();
        }
        fetchUnit();
        toggleModal();
      } catch (error) {
        console.log(error);
        toast.error(error?.response?.data);
      } finally {
        setLoading(false);
      }
    },
  });
  // Reset form when modal closes
  useEffect(() => {
    if (!modal) {
      formik.resetForm();
    }
  }, [modal]);
  return (
    <Offcanvas
      isOpen={modal}
      toggle={toggleModal}
      direction="end"
      backdropClassName="bg-dark bg-opacity-50"
      className="shadow-lg animate__animated animate__slideInRight bg-white "
      // id="offcanvasRight"
    >
      <OffcanvasHeader toggle={toggleModal}>
        <div className="d-flex align-items-center text-center justify-content-center w-100 gap-2">
          <i className="ri-stack-line"></i>
          <h5 className="mb-0">Customer Type Form</h5>
        </div>
      </OffcanvasHeader>
      <OffcanvasBody>
        <Form onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={12}>
              <div className="form-floating mb-3">
                <Input
                  id="name"
                  name="name"
                  type="text"
                  className="form-control"
                  placeholder="Enter customer type"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                  invalid={!!(formik.touched.name && formik.errors.name)}
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="name">Customer type</Label>
                {formik.touched.name && formik.errors.name && (
                  <FormFeedback type="invalid">
                    {formik.errors.name}
                  </FormFeedback>
                )}
              </div>
            </Col>
            <Col md={12}>
              <div className="form-floating mb-3">
                <Input
                  id="discountPercentage"
                  name="discountPercentage"
                  type="text"
                  className="form-control"
                  placeholder="Enter discount percentage"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.discountPercentage}
                  invalid={
                    !!(
                      formik.touched.discountPercentage &&
                      formik.errors.discountPercentage
                    )
                  }
                  style={{ padding: "0.5rem", height: "1rem" }}
                />
                <Label for="discountPercentage">Discount Percent</Label>
                {formik.touched.discountPercentage &&
                  formik.errors.discountPercentage && (
                    <FormFeedback type="invalid">
                      {formik.errors.discountPercentage}
                    </FormFeedback>
                  )}
              </div>
            </Col>
            <Col md={12} className="mb-3">
              {/* <div className="form-floating mb-3"> */}

              {/* <label htmlFor="description">Description</label> */}

              <textarea
                id="description"
                name="description"
                className={`form-control ${
                  formik.touched.description && formik.errors.description
                    ? "is-invalid"
                    : ""
                }`}
                placeholder="Enter description"
                rows={5}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.description}
                style={{ padding: "1rem" }} // optional styling
              />
              {formik.touched.description && formik.errors.description && (
                <div className="invalid-feedback">
                  {formik.errors.description}
                </div>
              )}
              {/* </div> */}
            </Col>
          </Row>

          <div className=" d-flex bg-white align-content-center align-items-center justify-content-between gap-2 position-absolute bottom-0 start-0 end-0 p-3">
            <button className="btn btn-danger w-100" onClick={toggleModal}>
              Cancel
            </button>

            <Button
              color="success"
              type="submit"
              disabled={loading}
              className="w-100"
            >
              {loading && <Spinner size="sm" className="me-2" />}
              {loading
                ? selectedUnit?.id
                  ? "Updating..."
                  : "Creating..."
                : selectedUnit?.id
                ? "Update"
                : "Create"}
            </Button>
          </div>
        </Form>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default CustomerTypeForm;
